module.exports = __webpack_public_path__ + "img/abstract-shapes-lego2.73658ba4.svg";